import ApiService from '@/services/api.service'

export default {
  index: () =>
    ApiService().get('/user/lead-stages'),

  store: (name: string) =>
    ApiService().post('/user/lead-stages', { name }),

  update: (id: number, name: string) =>
    ApiService().patch(`/user/lead-stages/${id}`, { name }),

  destroy: (id: number) =>
    ApiService().delete(`/user/lead-stages/${id}`),
}
